import {getYear, isValid} from 'date-fns';

import {isNotNil} from 'ramda-adjunct';

import {type SourcingVehicleResponseBody} from '@dms/api/core';

import {parseDate} from 'shared/web';

/**
 * The year shown on the car, otherwise the year of its manufacture date. The
 * BPM estimate falls back to it when the first registration is missing.
 *
 * `year` comes first on purpose: it is the year the user sees on the card, so
 * the estimate matches it. Where it is a model year ahead of the build year,
 * the result only becomes more pessimistic (younger car, higher BPM).
 */
export function getManufactureYear(
  vehicle: Pick<SourcingVehicleResponseBody, 'year' | 'manufactureDate'>
) {
  if (isNotNil(vehicle.year)) {
    return vehicle.year;
  }

  const manufactureDate = parseDate(vehicle.manufactureDate);

  return isNotNil(manufactureDate) && isValid(manufactureDate) ? getYear(manufactureDate) : null;
}
